import { useEffect } from "react";

const SITE_URL = "https://the3dcreator.com";
const DEFAULT_TITLE =
  "Custom 3D Printed Gifts, Corporate Gifting & Bulk Orders | The 3D Creator";
const DEFAULT_DESCRIPTION =
  "Shop custom 3D printed products for gifting, birthdays, corporate gifting, personalised keepsakes, and bulk 3D print orders at The 3D Creator.";
const DEFAULT_KEYWORDS =
  "custom 3d printed gifts, personalised 3d printed products, corporate gifting, birthday gifts, bulk 3d print orders, custom name gifts, desk accessories, customised keychains, 3d printing india, event gifting";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const ensureMetaTag = (attribute, value) => {
  const selector = `meta[${attribute}="${value}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, value);
    document.head.appendChild(tag);
  }

  return tag;
};

const ensureLinkTag = (rel) => {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);

  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }

  return tag;
};

export default function Seo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  pathname = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  structuredData = null,
}) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${pathname}`;
    const robotsContent = noindex
      ? "noindex, nofollow"
      : "index, follow, max-image-preview:large";

    document.title = title;

    ensureMetaTag("name", "description").setAttribute("content", description);
    ensureMetaTag("name", "keywords").setAttribute("content", keywords);
    ensureMetaTag("name", "robots").setAttribute("content", robotsContent);
    ensureMetaTag("name", "author").setAttribute("content", "The 3D Creator");
    ensureMetaTag("name", "twitter:card").setAttribute(
      "content",
      "summary_large_image",
    );
    ensureMetaTag("name", "twitter:title").setAttribute("content", title);
    ensureMetaTag("name", "twitter:description").setAttribute(
      "content",
      description,
    );
    ensureMetaTag("name", "twitter:image").setAttribute("content", image);

    ensureMetaTag("property", "og:type").setAttribute("content", type);
    ensureMetaTag("property", "og:title").setAttribute("content", title);
    ensureMetaTag("property", "og:description").setAttribute(
      "content",
      description,
    );
    ensureMetaTag("property", "og:url").setAttribute("content", canonicalUrl);
    ensureMetaTag("property", "og:image").setAttribute("content", image);
    ensureMetaTag("property", "og:site_name").setAttribute(
      "content",
      "The 3D Creator",
    );
    ensureMetaTag("property", "og:locale").setAttribute("content", "en_IN");

    ensureLinkTag("canonical").setAttribute("href", canonicalUrl);

    let scriptTag = document.getElementById("seo-structured-data");

    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.type = "application/ld+json";
      scriptTag.id = "seo-structured-data";
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = structuredData ? JSON.stringify(structuredData) : "";
  }, [description, image, keywords, noindex, pathname, structuredData, title, type]);

  return null;
}

export { SITE_URL, DEFAULT_IMAGE, DEFAULT_DESCRIPTION, DEFAULT_KEYWORDS };
